import axios from 'axios';

// Database Switcher Logic
const DB_TYPE = process.env.REACT_APP_DATABASE_TYPE || 'database'; // 'database' (Custom API) or 'firebase'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || ''
});

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('sas_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('sas_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export { DB_TYPE };
export default api;

